import { Type } from 'theme/types';
import { Title} from 'theme/theme';
import styled from "styled-components";


export const TitleProgress = styled(Title)`
  ${({theme}: Type) => theme?.prizes?.start?.text?.title}
`